import { createSlice } from "@reduxjs/toolkit";
import * as ContactUsApi from "../api/contact-us";

const contactUsDetail = createSlice({
  name: "contactUsDetail",
  initialState: {
    loading: false,
    error: null,
    item: null,
  },
  reducers: {
    setLoading: (state) => {
      state.error = null;
      state.loading = true;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    getDetailSuccess: (state, action) => {
      state.item = action.payload;
      state.loading = false;
    },
  },
});

export const getContactUsDetail = (id) => async (dispatch) => {
  try {
    dispatch(setLoading());
    const res = await ContactUsApi.getContactUsById(id);
    dispatch(getDetailSuccess(res));
  } catch (error) {
    dispatch(setError(error));
  }
};

const { reducer, actions } = contactUsDetail;
export const { setLoading, setError, getDetailSuccess } = actions;
export default reducer;
